import {
  useGetReportGeneralAttendanceQuery,
  useGetReportTestsPerformedQuery,
  useGetReportThresholdAlertsQuery,
  useGetReportMaternityAttendanceQuery,
  useGetReportMissingExamsQuery,
} from '@/core/services/statistics'

type UseMonthlyReportDataParams = {
  establishmentId: string
  startDate?: string
  endDate?: string
  isActive: boolean
}

export function useMonthlyReportData({ establishmentId, startDate, endDate, isActive }: UseMonthlyReportDataParams) {
  const queryParams = { establishment: establishmentId, startDate, endDate }
  const skip = !isActive || !establishmentId || !startDate || !endDate

  const generalAttendance = useGetReportGeneralAttendanceQuery(queryParams, { skip })
  const testsPerformed = useGetReportTestsPerformedQuery(queryParams, { skip })
  const thresholdAlerts = useGetReportThresholdAlertsQuery(queryParams, { skip })
  const maternityAttendance = useGetReportMaternityAttendanceQuery(queryParams, { skip })
  const missingExams = useGetReportMissingExamsQuery(queryParams, { skip })

  const isLoading =
    generalAttendance.isLoading ||
    testsPerformed.isLoading ||
    thresholdAlerts.isLoading ||
    maternityAttendance.isLoading ||
    missingExams.isLoading

  return {
    generalAttendance,
    testsPerformed,
    thresholdAlerts,
    maternityAttendance,
    missingExams,
    isLoading,
  }
}
